import { ClubComponent, ClubMessage } from './club.state';
import {
    IClubState,
    IClubMember,
} from '@soposopo/sopo-models';

import { createAction, props } from "@ngrx/store";

export const setChatLastMessageAction = createAction(
    '[CLUB] SET_LAST_CLUB_MESSAGE_ID',
    props<{
        messageId: string;
        clubId: string;
    }>()
);

export const clubEnteredAction = createAction(
    '[CLUB] Club Entered',
    props<{
        clubId: string;
    }>()
);

export const clubLeftAction = createAction(
    '[Router] Club Left',
);

export const clubFetchFailedAction = createAction(
    '[CLUB] Club Fetch Failed',
    props<{
        error: object;
    }>()
);

export const clubLoadedAction = createAction(
    '[CLUB] Club Data Loaded',
    props<{
        clubData: IClubState;
    }>()
);

export const clubLoadMessagesAction = createAction(
    '[CLUB] Load Club Messages',
    props<{
        messages: ClubMessage[];
    }>()
);

export const activateClubComponent = createAction(
    "[CLUB] ACTIVATE CLUB COMPONENT",
    props<{
        component: ClubComponent;
    }>()
);

export const setClubListeningAction = createAction(
    '[CLUB] SET CLUB LISTENING',
    props<{
        to: boolean;
    }>()
);

export const setMembersListeningAction = createAction(
    '[CLUB] SET MEMBERS LISTENING',
    props<{
        to: boolean;
    }>()
);

export const membersLoadedAction = createAction(
    '[CLUB] MEMBERS LOADED',
    props<{
        numberOfMembers: number;
        members: IClubMember[];
    }>()
);

export const memberModifiedAction = createAction(
    '[CLUB] MEMBERS MODIFIED',
    props<{
        modifiedMember: IClubMember;
    }>()
);

export const memberRemovedAction = createAction(
    '[CLUB] MEMBERS REMOVED',
    props<{
        numberOfMembers: number;
        removedMember: IClubMember;
    }>()
);

export const clearMembersState = createAction(
    '[CLUB] CLEAR MEMBERS STATE',
);

export const clearMessages = createAction(
    '[CLUB] CLEAR MESSAGES',
);
